export default function Lists() {
  return (
    <div className="text-center">
      <h1 className="text-5xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl">
        Slot Lists
      </h1>
    </div>
  );
}
